import { Observable } from 'rxjs';
import { TpvSettlement, TpvSettlementCreated } from '@app/domain/models/tpv/settlement.model';
import { TpvListQuery, TpvPage } from '@app/domain/models/tpv/tpv-page.model';
import { CreateSettlementRequest } from '@app/data/dtos/tpv/settlement.dto';

export interface SettlementListQuery extends TpvListQuery {}

/**
 * Port de liquidaciones del TPV.
 * `id_merchant` (`externalIdMerchant`, UUID) es OBLIGATORIO en toda lectura.
 */
export abstract class SettlementRepository {
  abstract getSettlements(
    externalIdMerchant: string,
    query?: SettlementListQuery,
  ): Observable<TpvPage<TpvSettlement>>;

  /** Detalle de UNA liquidación por su id (`GET /settlements/<id_settlement>/`). */
  abstract getSettlementById(
    idSettlement: string | number,
  ): Observable<TpvSettlement | null>;

  /**
   * Alta de liquidación (`POST /settlements/`, IsAdmin). La `Idempotency-Key` es
   * opcional; el guard real anti-doble-submit es la transición de la dispersión.
   */
  abstract createSettlement(
    request: CreateSettlementRequest,
    idempotencyKey?: string,
  ): Observable<TpvSettlementCreated>;
}
